import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { Field, FieldHeader } from 'web-ui-components/lib/molecules/forms';
import { AccordionTable } from 'web-ui-components/lib/molecules/accordions';
import { GenericTextArea } from 'web-ui-components/lib/data/capture';
import paymentsReasonContent, { contentPropTypes } from './PaymentsReasonSection.content';
import withContent from '../../../../containers/withContent';
import withValidation from '../../../../containers/withValidation';
import { swiftMultiChar } from '../../../../containers/withValidation';

export const REASON_PAYMENT_MAXIMUM_LENGTH = 140;

export const PaymentsReasonSection = ({
	onChange,
	reason,
	content: { header, description, purposeCodeMsg, reasonCodeHeader, emptyReasonWarning, invalidReasonWarning },
	countryCode,
	reasonCodeList,
}) => {
	const reasonIsInvalid = !swiftMultiChar(reason);
	const hasError = !reason || reason.length === 0;

	return (
		<Field>
			<FieldHeader
				name="payments-reason"
				titleText={header}
				description={description}
				validationMessage={reasonIsInvalid ? invalidReasonWarning : emptyReasonWarning}
				hasError={hasError || reasonIsInvalid}
			/>

			{countryCode && (
				<div>
					<p>{purposeCodeMsg}</p>
					<AccordionTable rows={reasonCodeList} title={reasonCodeHeader} />
				</div>
			)}
			<GenericTextArea maximumCharacters={REASON_PAYMENT_MAXIMUM_LENGTH} onChange={onChange} value={reason} />
		</Field>
	);
};

PaymentsReasonSection.propTypes = {
	content: PropTypes.shape(contentPropTypes),
	onChange: PropTypes.func.isRequired,
	countryCode: PropTypes.bool.isRequired,
	reason: PropTypes.string.isRequired,
	reasonCodeList: PropTypes.arrayOf(PropTypes.shape({})),
};
const validation = withValidation({
	validations: ['required', 'maxLength', 'iftReference'],
	key: 'reason',
	message: 'Please select one of the options.',
});
export default compose(withContent({ content: paymentsReasonContent }), validation)(PaymentsReasonSection);
